<template>
  <div>
    <media-browser 
      ref="browser" 
      image-picker
      @on-select="selectImage"
    />
  </div>
</template>

<script>
import MediaBrowser from './MediaBrowser';

export default {
  name: 'MediaChooser',
  components: {
    'media-browser': MediaBrowser
  },
  data: () => ({
    nodata: null
  }),
  methods: {
    selectImage: function(img) {
      if(!img.id) return;
      this.$emit('on-select', img);
    }
  }
}
</script>